type Listener = () => void;

let serverUnavailable = false;
const listeners = new Set<Listener>();

// Store-independent signal set by the axios interceptor when the API looks
// down (see isServerUnavailableError). It cannot live in Redux: the axios
// instance is created inside createBaseAxiosInstance(), which must not import
// the store (circular dependency), and instances are recreated on login /
// practice switch. Components subscribe via useSyncExternalStore.
export const maintenanceMode = {
    isServerUnavailable(): boolean {
        return serverUnavailable;
    },
    setServerUnavailable(value: boolean): void {
        if (serverUnavailable === value) {
            return;
        }
        serverUnavailable = value;
        listeners.forEach((listener) => listener());
    },
    subscribe(listener: Listener): () => void {
        listeners.add(listener);
        return () => {
            listeners.delete(listener);
        };
    },
};
